import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class SessionService {

  constructor() {}
  globallablesinfo;
  analticsTrackingId: string = null;
  userInfo: any = {
  user : null
  };
  assignUserInfo(info) {
    this.userInfo.user = info;
  }
  assignglobalinfo(globalinfodata) {
    this.globallablesinfo = globalinfodata;
  }

  SetAnalticsTrackingIdValue(analticsTrackingId) {
    this.analticsTrackingId = analticsTrackingId;
  }

}

